<script lang="ts">
    import SafeHtml from '@components/safe-html';
    import { trackEvent, trackView } from '@otto-ec/nexus-registry/pdp/tracking';
    import type { DescriptionDto } from '@views/description/types';

    let { description }: DescriptionDto = $props();

    let expanderElement: HTMLOcExpanderV1Element | undefined = $state();
    $effect(() => {
        if (!expanderElement) return;

        trackView({
            product_Description: [expanderElement.isCutOff ? 'foldable' : 'not_foldable'],
        });
    });

    const trackMore = () => {
        trackEvent({ product_Description: ['more'] });
    };

    const trackLess = () => {
        trackEvent({ product_Description: ['less'] });
    };
</script>

{#if description}
    <div class="pdp_description oc-background-color-canvas oc-px-100 oc-pb-150" data-ft5-visibility-tracking={'{"componentName":"description"}'}>
        <oc-expander-v1
            bind:this={expanderElement}
            class="oc-copy-100"
            variant="text"
            cutoff-height={200}
            oc-aria-label="Description expander"
            onoc-open={trackMore}
            onoc-close={trackLess}
        >
            <SafeHtml html={description} />
        </oc-expander-v1>
    </div>
{/if}
